/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.recommendModule')
.directive('bulbRecommendHeader', bulbRecommendHeader);

function bulbRecommendHeader() {
  return {
    restrict: 'E',
    templateUrl: 'ajs/components/recommend/recommendheader.html',
    controller: 'RecommendController as recommendCtrl',
    link: function(scope, element, attrs) {
      if ('initializeTrigger' in attrs) {
        // Wait to make the first server request until initializeTrigger evaluates to true
        var unobserve = attrs.$observe('initializeTrigger', function(value) {
          if (scope.$eval(value)) {
            scope.recommendCtrl.getInitialRecommends();
            unobserve();
          }
        });
      }
    }
  };
}
